var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSplitterArrows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 860,
    viewBox: "0 0 20 860",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10676_121661)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.66797 13.3327L3.33464 9.99935L6.66797 6.66602",
    stroke: "#979797",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.334 13.3327L16.6673 9.99935M16.6673 9.99935L13.334 6.66602M16.6673 9.99935L3.33398 9.99935",
    stroke: "#979797",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSplitterArrows);
export default __webpack_public_path__ + "static/media/splitter_arrows.13415c26f0cd4b7fb7e03ef0d5aef996.svg";
export { ForwardRef as ReactComponent };